import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { actions as userActions } from '../../actions/userActions';
import * as types from '../../constants/actionTypes';
import Notification from '../Common/Notification';
import NotificationSettingsForm from './NotificationSettingsForm';
import './NotificationSettings.scss';
import LoadingIndicator from './../Common/LoadingIndicator/LoadingIndicator';
import MomentTz from 'moment-timezone';

export class NotificationSettingsPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        const settings = {
            alertOnNewUserRequest: false,
            alertOnLocationCreated: false,
            alertOnTaskAssigned: false,
            alertForDailyDigest: false,
            alertForWeeklyDigest: false,
            alertOnProjectAssigned: false,
            alertOnCommentTag: false,
            alertOnSystemUpdates: false,
            alertOnSpecificLocations: 0,
            alertOnNeedResources: false,
            alertOnAssignedTask: false,
            locationIds: '',
            alertDayOfWeekId: '',
            alertHourOfDayId: '',
            timezoneOffset: 0,
            timezoneString: "",
            timezone: "",
            isFormValid: true,
            isToolTipsActive: false
        };

        this.state = {
            settings,
            isLoading: false
        }
    }

    componentDidMount = () => {
        this.setTimeZone();
    };

    setTimeZone = () => {
        const tz = MomentTz.tz.guess();
        const offsetMinutes = MomentTz.tz(tz)._offset;
        const zone = MomentTz.tz(tz).format("zz");
        this.setState({ timezoneString: `${tz} ${zone}`, timezone: tz, timezoneOffset: offsetMinutes });
    }

    updateSettings = (settings) => {
        this.setState({
            settings: {
                ...this.state.settings,
                ...settings
            }
        });
    };

    isFormValid = () => {
        if (this.state.settings.alertOnSpecificLocations === 1 && (this.state.settings.locationIds.trim().length < 1 || !this.state.settings.locationIds.trim())) {
            return false;
        }

        if (this.state.settings.alertHourOfDayId === '' || this.state.settings.alertDayOfWeekId === '') {
            return false;
        }

        return true;
    }

    onSaveChanges = async () => {
        if (this.isFormValid() === false) {
            this.updateSettings({ isFormValid: false });
            return;
        }

        this.updateSettings({ isFormValid: true });

        let locationIds = [];
        if (this.state.settings.alertOnSpecificLocations === 1) {
            locationIds = this.state.settings.locationIds.split(',');
        }

        const request = {
            ...this.state.settings,
            locationIds: locationIds,
            timezoneOffset: this.state.timezoneOffset,
            userId: this.props.userId
        };

        try {
            this.setState({ isLoading: true });
            const result = await this.props.userActions.saveNotificationSettings(request);

            if (result.type === types.SAVE_NOTIFICATION_SETTINGS_SUCCESS) {
                Notification("success", "Success", "Notification settings updated successfully");
            } else if (result.type === types.SAVE_NOTIFICATION_SETTINGS_FAILURE) {
                Notification("error", "Error", result.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        return (
            <div className="notification-settings-wrapper">
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="notification-settings">
                        <h2 className="notification-settings-header">Notification Settings</h2>
                        
                            <NotificationSettingsForm 
                                settings={this.state.settings}
                                updateSettings={this.updateSettings}
                                userId={this.props.userId}
                                userRole={this.props.userRole}
                                timezone={this.state.timezone}
                                timezoneString={this.state.timezoneString}
                            />
                        
                    </div>
                    <div className="notification-settings">
                        <div className="footer text-end">
                            <button name="eventNotificationsSaveButton" className="btn btn-primary save-changes" onClick={this.onSaveChanges}>Save Changes</button>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        )
    }
}

NotificationSettingsPage.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    userActions: PropTypes.object.isRequired,
    userId: PropTypes.number.isRequired,
    userRole: PropTypes.string
};

function mapStateToProps(state) {
    return {
        userId: state.user.id,
        userRole: state.user.customerRole,
        subscriptionId: state.user.currentSubscriptionId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettingsPage);

